import * as React from 'react';
import { classNames } from '@wix/answers-lib';
import { isArray } from 'util';
import { TinyLoader } from '../loaders';
import { Virtuoso } from 'react-virtuoso';
import { isFeatureEnabled } from '@wix/answers-experiments';
export function InfiniteScroll(props) {
    var _a, _b;
    var visibleItems = React.useRef([]);
    var _c = React.useState(false), atBottom = _c[0], setAtBottom = _c[1];
    var showEmptyState = React.useMemo(function () {
        if (props.showEmptyState) {
            return true;
        }
        return Array.isArray(props.data) && props.data.length === 0;
    }, [props.data, props.showEmptyState]);
    var showLoader = React.useMemo(function () { return !isArray(props.data); }, [props.data]);
    var showLoadMore = React.useMemo(function () { return props.hasMore && !showEmptyState && isArray(props.data); }, [showEmptyState, props.data, props.hasMore]);
    var itemsRendered = function (item) {
        if (!props.onVisibleItemsChanged) {
            return;
        }
        var indexes = item.map(function (i) { return i.index; });
        visibleItems.current = indexes;
        props.onVisibleItemsChanged(visibleItems.current);
    };
    var footer = function () {
        return showLoadMore
            ? (React.createElement("div", { className: classNames('infinite-scroll-loader load-more', props.className || '') }, props.loadingMoreElement ? props.loadingMoreElement : React.createElement(TinyLoader, null)))
            : null;
    };
    var height = props.HeightProps ? props.HeightProps.itemHeight * (((_a = props.data) === null || _a === void 0 ? void 0 : _a.length) || 0) + "px" : '100%';
    var maxHeight = props.HeightProps ? props.HeightProps.maxHeight + "px" : '100%';
    var body = showEmptyState
        ? props.emptyState
        : (React.createElement(Virtuoso, { onScrollCapture: props.onScroll, endReached: showLoadMore ? props.onLoadMore : undefined, components: { Footer: atBottom ? footer : undefined }, totalCount: ((_b = props.data) === null || _b === void 0 ? void 0 : _b.length) || 0, itemContent: props.itemContent, itemsRendered: itemsRendered, initialItemCount: props.initialItemCount, fixedItemHeight: props.fixedItemHeight, className: "infinite-scroll-inner " + (props.className || ''), atBottomStateChange: setAtBottom, style: { height: maxHeight, maxHeight: height } }));
    var itemsLoader = (React.createElement("div", { className: classNames('infinite-scroll infinite-scroll-container', props.className) },
        React.createElement("div", { className: 'list-loader' },
            React.createElement(TinyLoader, null))));
    var withContainer = (React.createElement("div", { className: classNames('infinite-scroll infinite-scroll-container', props.className) },
        showLoader ? React.createElement("div", { className: 'list-loader' },
            React.createElement(TinyLoader, null)) : null,
        body));
    return isFeatureEnabled('InfiniteScrollRemoveContainer') ? (React.createElement(React.Fragment, null,
        showLoader ? itemsLoader : null,
        body)) : withContainer;
}
//# sourceMappingURL=index.js.map